import Env from "../env/Env";
import createAxiosInstance from "../utils/axiosInstance";

const sharedClient = createAxiosInstance(`${Env.API_BASE}/api/graphs/shared`);
const adminClient = createAxiosInstance(`${Env.API_BASE}/api/admins/dashboard`);

export function isAbortLikeError(e: unknown): boolean {
  const err = e as { name?: string; code?: string };
  return (
    err?.name === "CanceledError" ||
    err?.name === "AbortError" ||
    err?.code === "ERR_CANCELED"
  );
}

/** Warms `resolveCommonFilters` Redis entry before parallel `/api/graphs/dashboard-*` calls. */
export async function runSharedResolvedFiltersPreflight(
  filters: Record<string, any>,
  signal?: AbortSignal
): Promise<void> {
  await sharedClient.get("/resolved-common-filters", { params: filters, signal });
}

/** Warms admin `resolveCommonFilters` cache (incl. manager subordinates) before parallel admin dashboard GETs. */
export async function runAdminResolvedFiltersPreflight(
  filters: Record<string, any>,
  signal?: AbortSignal
): Promise<void> {
  await adminClient.get("/resolved-common-filters", { params: filters, signal });
}
